<app-challenges-base-card
  [challenge]="challenge"
  [createdByLabel]="'challenges.createdByYou'"
  [icon]="'challenge_monthly'"
  [iconSize]="'2x'"
  [progressLabel]="'challenges.consumedContent'"
  [showEditMenu]="challenge !== undefined"
  (deleteChallenge)="handleDelete()"
  (updateChallenge)="handleUpdate()">
  <div class="create-container" slot="empty-challenge">
    <span> {{ 'challenges.monthlyGoalText' | translate }} </span>

    <opac-button (click)="handleCreateButtonClick()">
      <opac-icon icon="event_available" slot="start"></opac-icon>
      {{ 'challenges.monthlyTitle' | translate }}
    </opac-button>
  </div>

  <app-challenges-monthly-content *ngIf="challenge?.contents.length" [swiperMonthlyItems]="challenge?.contents"></app-challenges-monthly-content>
</app-challenges-base-card>